import { Loader, Stack } from "@mantine/core";
import { DEFAULT_WHITE_COLOR } from "../../../_graphic_design";
import { EventHeader } from "event/play/components/EventHeader";

const PlayLoader = ({
  message,
  icon = <Loader variant={"bars"} color={DEFAULT_WHITE_COLOR} />,
}: {
  message: JSX.Element | string;
  icon?: JSX.Element;
}) => {
  return (
    <Stack className="h-screen justify-start" justify="center" align={"center"}>
      <EventHeader />
      {icon}
      {message}
    </Stack>
  );
};

export { PlayLoader };
